module.exports = __webpack_public_path__ + "static/img/KLrzPbVw.bcb349b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/KLrzPbVw.jpg
// module id = USu2
// module chunks = 7